import { Component, OnInit } from '@angular/core';
import { ParamService } from '../../../../shared/services/param.service';

@Component({
  selector: 'point-reward-grid-promotion',
  templateUrl: './point-reward-grid-promotion.component.html',
  styleUrls: ['./point-reward-grid-promotion.component.scss']
})

export class PointRewardGridPromotionComponent implements OnInit{
  imageSrc: string;

  promoAltText: string;
  promoLinkPath: string;
  openInNewTab: boolean;
  textPlateDisplay: boolean;

  textPlateHeaderText: string;
  textPlateSubText: string;
  textPlateCTALabel: string;

  constructor(private paramService: ParamService) {
  }

  ngOnInit(): void {
    this.textPlateDisplay = true;
    this.openInNewTab = true;
    this.imageSrc =
        "https://images.albertsons-media.com/is/image/ABS/starbucks-banner-full-test";
    this.promoAltText = "Starbucks Drinks";
    this.textPlateHeaderText = "<p>Summer Forever</p>";
    this.textPlateSubText = "<p>Treat yourself to something special</p>";
    this.textPlateCTALabel = "Find a café near you";
    this.promoLinkPath = "https://local." + this.paramService.banner + ".com/search.html";
  }

}
